import React, { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import WizardButton from '../WizardButton';

import WizardStepDefault from './WizardStepDefault';
import * as actions from '../../../store/actions/index';
import Aux from '../../../hoc/Aux';
import { useTranslation } from 'react-i18next';


const wizardStepExecutionType = (props) => {

  const getButtonsUrl = '/api/step_combinations/execution_type?country=' + props.selectedSteps.country + '&fwk=' + props.selectedSteps.fwk + '&installation_location=' + props.selectedSteps.location
  const onSelectAction = (stepValue) => { return actions.wizardSelectExecutionType(stepValue)}

  const dispatch = useDispatch();
  const { t } = useTranslation();


  const onSelectDirectResults = useCallback(
      () => dispatch(actions.wizardGoToResults()),
      [dispatch]
    )

    if (props.currentStep !== 'execution_type') {
      return null;
    }

  return(
      <Aux>
        <WizardStepDefault
          stepName='execution_type'
          getButtonsUrl={getButtonsUrl}
          onSelectAction={onSelectAction}
          currentStep={props.currentStep}
          modalTextToken={ 'wizard.steps.execution_type.infotext' }
          />

          <div className="row justify-content-center">
            <div className="col-lg-11 col-xl-11">
              <div className="row">
                <WizardButton key={'direct_results'} title={ t('wizard.steps.fork.values.direct_results') } onClick={onSelectDirectResults} btnStyle={"wizzard-three yellow-btn"} />
              </div>
            </div>
          </div>
      </Aux>


 );
};

export default wizardStepExecutionType;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepExecutionType.js